import { round } from 'lodash';

const useClusterInfoBox = ({ width, height }) => {
  const hideInfoBox = svg => {
    setTimeout(() => {
      console.log('HIDE INFOBOX');
      svg.select('.fObjInfoBox').selectAll('.ibDiv').remove();
    }, 100);
  };

  const showInfoBox = (svg, dd, x, y) => {
    svg.select('.fObjInfoBox').selectAll('.ibDiv').remove();

    console.log('SHOW INFOBOX');
    const fObj = svg
      .select('.fObjInfoBox')
      .attr('width', `${width}px`)
      .attr('height', `${height}px`)
      .attr('x', x)
      .attr('y', y - (height + 5))
      .style('overflow', 'visible');

    // setTimeout(() => {
    const dObj = fObj
      .append('xhtml:div')
      .attr('class', 'ibDiv')
      .attr('id', 'ibDiv')
      .style('width', '100%')
      .style('height', '100%')
      .style(
        'box-shadow',
        '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
      )
      .style('background', 'white')
      .style('display', 'flex')
      .style('flex-direction', 'column');

    const div1 = dObj
      .append('xhtml:div')
      .attr('class', `ibox_colorrect`)
      .style('width', '100%')
      .style('height', '22px')
      .style('margin-top', '6px')
      .style('margin-bottom', '6px')
      .style('display', 'flex')
      .style('flex-direction', 'row');

    div1
      .append('xhtml:div')
      .attr('class', `ibox_colorrect`)
      .style('background', dd.color)
      .style('border-radius', '50%')
      .style('padding', '1px')
      .style('margin', '3px')
      .style('width', '20px')
      .style('height', '20px');

    div1
      .append('xhtml:label')
      .attr('class', 'scatter-ibox-label')
      .text(dd.segment.segmentName);

    dObj
      .append('xhtml:label')
      .attr('class', 'scatter-ibox-label')
      .style('line-height', '12px')
      .text(`Sample Size: ${dd.segment.sample}`);

    dObj
      .append('xhtml:label')
      .attr('class', 'scatter-ibox-label')
      .style('line-height', '10px')
      .text(`Segment Size (Weighted): ${round(dd.segment.pct, 1)}`);
  };

  return [showInfoBox, hideInfoBox];
};

export default useClusterInfoBox;
